// extracted by mini-css-extract-plugin
export default {"napsa-header":"NapsaReport_napsa-header__K4KhM","divider":"NapsaReport_divider__88Q5Z"};